import { render, staticRenderFns } from "./ModalProductList.vue?vue&type=template&id=031ca7a2&scoped=true"
import script from "./ModalProductList.vue?vue&type=script&lang=js"
export * from "./ModalProductList.vue?vue&type=script&lang=js"
import style0 from "./ModalProductList.vue?vue&type=style&index=0&id=031ca7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ca7a2",
  null
  
)

export default component.exports